import {downgradeComponent} from '@angular/upgrade/static';
import {barnManagerModule} from '../../index.module';
import {allowAttribute} from '../allow-attribute';
import {MatIcon} from '@angular/material/icon';

barnManagerModule.directive('ng2MatIcon', allowAttribute(downgradeComponent({ component: MatIcon })));
